import React from 'react'
import {
  IconButton,
  IconDelete20,
} from '@lightspeed/unified-components-helios-theme/react'
import type { DeleteButtonProps } from './DeleteButtonProps'

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  className: _className,
  modifier: _modifier,
  variant: _variant,
  'data-track': _dataTrack,
  'data-testid': _dataTestId,
  onClick,
  ...props
}) => {
  return (
    <div className="uc-base">
      <IconButton
        appearance="secondary"
        {...props}
        // UC's IconButton types onClick as (e: MouseEvent) but actually passes
        // a React.MouseEvent at runtime. Cast to satisfy UC's incorrect type.
        onClick={(onClick as unknown) as (e: MouseEvent) => void}
      >
        <IconDelete20 />
      </IconButton>
    </div>
  )
}
